var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.78 9.19603C17.78 8.58444 17.7251 7.99637 17.6232 7.43182H9.5V10.7681H14.1418C13.9419 11.8463 13.3342 12.7597 12.4207 13.3713V15.5354H15.2082C16.8391 14.0339 17.78 11.8227 17.78 9.19603Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49961 17.6249C11.8284 17.6249 13.7807 16.8525 15.2078 15.5353L12.4203 13.3712C11.648 13.8887 10.6601 14.1945 9.49961 14.1945C7.25319 14.1945 5.35176 12.6772 4.67353 10.6386H1.79199V12.8733C3.2112 15.6921 6.12802 17.6249 9.49961 17.6249Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67392 10.6388C4.50142 10.1213 4.40341 9.56852 4.40341 9.00006C4.40341 8.43159 4.50142 7.87881 4.67392 7.36131V5.12665H1.79239C1.20824 6.29102 0.875 7.6083 0.875 9.00006C0.875 10.3918 1.20824 11.7091 1.79239 12.8735L4.67392 10.6388Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49961 3.8054C10.7659 3.8054 11.9028 4.24057 12.7967 5.09523L15.2705 2.62142C13.7768 1.22966 11.8244 0.375 9.49961 0.375C6.12802 0.375 3.2112 2.30778 1.79199 5.12659L4.67353 7.36125C5.35176 5.32261 7.25319 3.8054 9.49961 3.8054Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo-google.f3d71019f3f0bae6a4b50cb8929a75b1.svg";
export { ForwardRef as ReactComponent };